import { render, staticRenderFns } from "./issuebook.vue?vue&type=template&id=7baf42a2&"
import script from "./issuebook.vue?vue&type=script&lang=js&"
export * from "./issuebook.vue?vue&type=script&lang=js&"
import style0 from "./issuebook.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports